import linq from 'linq'
import { snakeToCamel, camelToSnake } from '../utility/stringUtility'
import Color from './Color'
import Size from './Size'
import Stock from './Stock'
import Pattern from './Pattern'
import Product from './Product'
import ColorProductImages from './ColorProductImage'
import Form from 'vform'
import { arrayWrap } from '../utility/arrayUtitlity'

const FILLABEL = [
    'id',
    'productId',
    'patternId',
    'colorId',
    'sizeId',
    'code',
    'priceJpy',
    'volume',
    'isOnlyCharter',
]

const PRESENTS = ['priceJpy', 'volume', 'isOnlyCharter']

export default class Item {
    constructor(data = null) {
        this.originalData = data

        this.id = 0
        this.productId = 0
        this.patternId = 0
        this.colorId = 0
        this.sizeId = 0
        this.code = ''
        this.stocks = []
        this.priceJpy = 0
        this.volume = 0
        this.isOnlyCharter = false

        this.product = new Product()
        this.pattern = new Pattern()
        this.color = new Color()
        this.size = new Size()
        this.colorProductImagePath = ''

        this.form = new Form()

        this.changed = this.initChanged()

        if (data) {
            this.create()
        }
    }

    get _model() {
        return 'Item'
    }

    get price() {
        if(this.priceJpy === 0) {
            return 'ask'
        }
        return `¥${this.priceJpy.toLocaleString()}`
    }

    initChanged() {
        return {
            isChange: false,
            code: false,
            product: false,
            pattern: false,
            color: false,
            size: false,
            priceJpy: false,
            volume: false,
            isOnlyCharter: false,
        }
    }

    create(data = null) {
        const src = data || this.data

        linq.from(src)
            .select((x) => {
                x.key = camelToSnake(x.key)
                return x
            })
            .where((x) => this.hasOwnProperty(snakeToCamel(x.key)))
            .select((x) => {
                const key = snakeToCamel(x.key)

                if (typeof this[key] === 'number') {
                    this[key] = Number(x.value)
                    return
                }

                if (key === 'product') {
                    this[key] = new Product(x.value)
                    this.productId = this[key].id
                    return
                }

                if (key === 'pattern') {
                    this[key] = new Pattern(x.value)
                    this.patternId = this[key].id
                    return
                }

                if (key === 'color') {
                    this[key] = new Color(x.value)
                    this.colorId = this[key].id
                    return
                }

                if (key === 'size') {
                    this[key] = new Size(x.value)
                    this.sizeId = this[key].id
                    return
                }

                if (key === 'stocks') {
                    this[key] = linq
                        .from(x.value)
                        .select((x) => new Stock(x))
                        .toArray()
                    return
                }

                if (key === 'colorProductImages') {
                    this[key] = linq
                        .from(x.value)
                        .select((x) => new ColorProductImages(x))
                        .toArray()
                    return
                }

                this[key] = x.value
                return x
            })
            .toArray()

        this.createCode()
    }

    get data() {
        return this.originalData
    }

    get hasError() {
        return Object.keys(this.form.errors.errors).length
    }

    get errors() {
        return linq
            .from(this.form.errors.errors)
            .select((x) => {
                return arrayWrap(x.value)[0]
            })
            .toArray()
    }

    createCode() {
        if (!this.product.id) return
        this.code = `${this.product.pattern.code}${this.color.code}${this.size.code}`
    }

    joinWhere(x) {
        return linq.from(PRESENTS).any((xs) => x.key === xs)
    }

    getPostable() {
        return linq
            .from(this)
            .where((x) => linq.from(FILLABEL).any((xs) => xs === x.key))
            .where((x) => x.value || this.joinWhere(x))
            .select((x) => {
                return {
                    key: camelToSnake(x.key),
                    value: x.value,
                }
            })
            .toObject('$.key', '$.value')
    }

    fill() {
        this.form = new Form(this.getPostable())
    }

    async post(url) {
        this.fill()
        return await this.form.post(url)
    }

    async delete(url) {
        this.fill()
        return await this.form.delete(url)
    }

    async patch(url) {
        this.fill()
        return await this.form.patch(url)
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/models/Item.js